import { css, styled } from '@lichtblick/styled';
import { BorderRadius, BorderWidth, Colors, Spacing } from '@lichtblick/theme';

export const TableContainer = styled.div<{ $isFullHeight: boolean | undefined }>`
  border-color: ${Colors.blue[20]};
  border-radius: ${BorderRadius.S};
  border-spacing: 0;
  border-style: solid;
  border-width: ${BorderWidth.Table};
  height: ${({ $isFullHeight }) => ($isFullHeight ? '100%' : 'auto')};
  overflow: auto;
  table-layout: fixed;
  width: 100%;

  &::-webkit-scrollbar {
    height: 0.375rem;
    width: 0.375rem;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${Colors.blue[20]};
    border-radius: ${BorderRadius.Xxs};
  }

  &::-webkit-scrollbar-track-piece {
    background: transparent;
  }
`;

export const Table = styled.table`
  border-spacing: 0;
  font-weight: 400;
  width: 100%;
`;

export const TableThead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const TableHeader = styled.th<{ $isInteractive: boolean }>`
  background-color: ${Colors.blue[3]};
  border-bottom: ${BorderWidth.Table} solid ${Colors.blue[20]};
  font-weight: 400;
  padding: 0.75rem ${Spacing.Xs};
  text-align: left;

  &:hover {
    background-color: ${({ $isInteractive }) => $isInteractive && Colors.blue[20]};
  }
`;

export const TableTd = styled.td<{ $isOpen: boolean }>`
  ${({ $isOpen }) => {
    return $isOpen
      ? css`
          background-color: ${Colors.blue[3]};
        `
      : css`
          border-bottom: solid;
          border-bottom-color: ${Colors.blue[20]};
          border-width: ${BorderWidth.Table};
        `;
  }}
  overflow: 'hidden';
  text-align: left;
  text-overflow: 'ellipsis';
  white-space: 'nowrap';
`;

export const Flex = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.Xxs};
`;

export const TableData = styled(TableTd)`
  height: 4.0625rem;
  max-width: 'max-content';

  > a {
    align-items: center;
    display: flex;
    height: 100%;

    padding: 0 ${Spacing.Xs} 0 ${Spacing.Xs};
    width: 100%;

    > span {
      width: 100%;
    }
  }
`;

export const LazyLoadTrigger = styled.div`
  position: relative;
`;

export const CheckboxContainer = styled.div`
  padding-left: ${Spacing.Xs};
`;
